import { render, staticRenderFns } from "./DaDataSuggestions.vue?vue&type=template&id=5b53f015"
import script from "./DaDataSuggestions.vue?vue&type=script&lang=js"
export * from "./DaDataSuggestions.vue?vue&type=script&lang=js"
import style0 from "./DaDataSuggestions.vue?vue&type=style&index=0&id=5b53f015&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports